import { Notifications } from "common/Notifications";
import { useGtmAuthorisation } from "core/analytics/google-tag-manager/google-tag-manger.hooks";
import { useCurrentUserQuery } from "core/gateways/user/user.hooks";
import { PropsWithChildren, ReactNode } from "react";

import {
  Customizer,
  IMessageBarProps,
  mergeStyles,
  MessageBarType,
  Stack
} from "@bps/fluent-ui";

export interface MainLayoutProps {
  navBar?: ReactNode;
}

const messageBarSettings: Partial<IMessageBarProps> = {
  styles: props => ({
    root: props.messageBarType === MessageBarType.info && {
      background: props.theme.palette.white
    }
  })
};

export const MainLayout = ({
  navBar,
  children
}: PropsWithChildren<MainLayoutProps>) => {
  const userQuery = useCurrentUserQuery();
  useGtmAuthorisation(userQuery.data);

  const mainStyles = mergeStyles({
    flexGrow: 1,
    backgroundColor: "#f3f3f4",
    overflow: "auto",
    padding: "8px 16px 8px 16px",
    position: "relative"
  });

  return (
    <Stack verticalFill>
      {navBar}
      <Customizer
        scopedSettings={{
          MessageBar: messageBarSettings
        }}
      >
        <Notifications />
      </Customizer>
      <main className={mainStyles}>{children}</main>
    </Stack>
  );
};
